import { queryOptions } from '@tanstack/react-query';
import { getVenues } from '../actions/getVenues';

export const VenuesQuery = queryOptions({
    queryKey: ['VENUES'],
    queryFn: getVenues,
});
